/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Account_TitleInputs */

const en_start_page_account_title = /** @type {(inputs: Start_Page_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account and a page in fifteen minutes.`)
};

const pl_start_page_account_title = /** @type {(inputs: Start_Page_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto i strona w kwadrans.`)
};

/**
* | output |
* | --- |
* | "An account and a page in fifteen minutes." |
*
* @param {Start_Page_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_account_title = /** @type {((inputs?: Start_Page_Account_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Account_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_account_title(inputs)
	return en_start_page_account_title(inputs)
});